// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/ai-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}

.ai-heading {
  color: #fff !important;
  margin: 0 !important;
  letter-spacing: 0.125rem;
  font-weight: bold;
}

.ai .content {
  border-radius: 10px;
  background: #28323c;
  padding: 10px 30px 40px 30px;
}

.ai .content .main-heading {
  font-size: 16px;
  font-weight: 600;
  /* line-height: 24px; */
  color: #fff !important;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.ai .heading {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.ai .heading .ant-picker {
  background: transparent;
}

/* .ai .ant-picker-panel-container .ant-picker-panel-container{
    background: red !important;
} */

.ai .heading img {
  width: 30px;
}

.ai .content .section {
  padding: 20px;
  /* background: #D9D9D9; */
  background: rgb(217, 217, 217, 0.2);
  height: 100%;
  /* display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column; */
}

.ai .content .section .sub-haeding {
  text-transform: uppercase;
  color: #fff !important;
}

.ai .content .section .graph {
  /* display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 0; */
  /* /* width: 100%; */
  height: 200px;
}

/* .ai .content .section .graph canvas{
height: 200px !important;
} */

.ai .content .section .pie-graph canvas {
  height: 305px !important;
}

.ai .content .location-section {
  padding: 20px 40px;
  /* background: #D9D9D9; */
  background: rgb(217, 217, 217, 0.2);
  height: 145px;
}

.ai .content .location-section h3 {
  color: #fff !important;
  text-align: center;
  text-transform: capitalize;
}

.ai .content .location-section .flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ai .content .location-section .location {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.ai .content .location-section .location h3 {
  color: #0ce3fb !important;
  text-align: center;
  text-transform: capitalize;
}

.ai .content .location-section .location h4 {
  color: #fff !important;
  text-transform: capitalize;
  font-weight: 600;
}

.ai .content .product-section {
  padding: 20px 40px;
  /* background: #D9D9D9; */
  background: rgb(217, 217, 217, 0.2);
  height: 100%;
}

.ai .content .product-section canvas {
  height: 145px !important;
}

.ai .content .product-section h3 {
  color: #fff !important;
  text-align: center;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/ai.css"],"names":[],"mappings":"AAAA;EACE,yDAA6C;EAC7C,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mCAAmC;EACnC,YAAY;EACZ;;;6BAG2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;;;qBAGmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".ai {\r\n  background-image: url(../../assets/ai-bg.png);\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n.ai-heading {\r\n  color: #fff !important;\r\n  margin: 0 !important;\r\n  letter-spacing: 0.125rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.ai .content {\r\n  border-radius: 10px;\r\n  background: #28323c;\r\n  padding: 10px 30px 40px 30px;\r\n}\r\n\r\n.ai .content .main-heading {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  /* line-height: 24px; */\r\n  color: #fff !important;\r\n  text-transform: capitalize;\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 0;\r\n}\r\n.ai .heading {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.ai .heading .ant-picker {\r\n  background: transparent;\r\n}\r\n\r\n/* .ai .ant-picker-panel-container .ant-picker-panel-container{\r\n    background: red !important;\r\n} */\r\n\r\n.ai .heading img {\r\n  width: 30px;\r\n}\r\n\r\n.ai .content .section {\r\n  padding: 20px;\r\n  /* background: #D9D9D9; */\r\n  background: rgb(217, 217, 217, 0.2);\r\n  height: 100%;\r\n  /* display: flex;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    flex-direction: column; */\r\n}\r\n\r\n.ai .content .section .sub-haeding {\r\n  text-transform: uppercase;\r\n  color: #fff !important;\r\n}\r\n\r\n.ai .content .section .graph {\r\n  /* display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: auto 0; */\r\n  /* /* width: 100%; */\r\n  height: 200px;\r\n}\r\n\r\n/* .ai .content .section .graph canvas{\r\nheight: 200px !important;\r\n} */\r\n\r\n.ai .content .section .pie-graph canvas {\r\n  height: 305px !important;\r\n}\r\n\r\n.ai .content .location-section {\r\n  padding: 20px 40px;\r\n  /* background: #D9D9D9; */\r\n  background: rgb(217, 217, 217, 0.2);\r\n  height: 145px;\r\n}\r\n\r\n.ai .content .location-section h3 {\r\n  color: #fff !important;\r\n  text-align: center;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.ai .content .location-section .flex {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.ai .content .location-section .location {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.ai .content .location-section .location h3 {\r\n  color: #0ce3fb !important;\r\n  text-align: center;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.ai .content .location-section .location h4 {\r\n  color: #fff !important;\r\n  text-transform: capitalize;\r\n  font-weight: 600;\r\n}\r\n\r\n.ai .content .product-section {\r\n  padding: 20px 40px;\r\n  /* background: #D9D9D9; */\r\n  background: rgb(217, 217, 217, 0.2);\r\n  height: 100%;\r\n}\r\n\r\n.ai .content .product-section canvas {\r\n  height: 145px !important;\r\n}\r\n\r\n.ai .content .product-section h3 {\r\n  color: #fff !important;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
